'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_SECTION_EXPANDED = exports.SORT_NAVIGATION_ITEMS_SUCCESS = exports.SORT_NAVIGATION_ITEMS_FAILURE = exports.SORT_NAVIGATION_ITEMS_REQUEST = exports.FETCH_PAGES_SUCCESS = exports.FETCH_PAGES_FAILURE = exports.FETCH_PAGES_REQUEST = exports.FETCH_NAVIGATION_ITEMS_SUCCESS = exports.FETCH_NAVIGATION_ITEMS_FAILURE = exports.FETCH_NAVIGATION_ITEMS_REQUEST = exports.EDIT_NAVIGATION_ITEM = exports.DELETE_NAVIGATION_ITEM_SUCCESS = exports.DELETE_NAVIGATION_ITEM_FAILURE = exports.DELETE_NAVIGATION_ITEM_REQUEST = exports.COMMIT_EDITING_NAVIGATION_ITEM_SUCCESS = exports.COMMIT_EDITING_NAVIGATION_ITEM_FAILURE = exports.COMMIT_EDITING_NAVIGATION_ITEM_REQUEST = exports.CHANGE_EDITING_NAVIGATION_ITEM = exports.CANCEL_EDITING_NAVIGATION_ITEM = exports.ADD_SECTION = exports.ADD_LINK = undefined;
exports.addLink = addLink;
exports.addSection = addSection;
exports.cancelEditingNavigationItem = cancelEditingNavigationItem;
exports.changeEditingNavigationItem = changeEditingNavigationItem;
exports.commitEditingNavigationItemRequest = commitEditingNavigationItemRequest;
exports.commitEditingNavigationItemFailure = commitEditingNavigationItemFailure;
exports.commitEditingNavigationItemSuccess = commitEditingNavigationItemSuccess;
exports.commitEditingNavigationItem = commitEditingNavigationItem;
exports.deleteNavigationItemRequest = deleteNavigationItemRequest;
exports.deleteNavigationItemFailure = deleteNavigationItemFailure;
exports.deleteNavigationItemSuccess = deleteNavigationItemSuccess;
exports.deleteNavigationItem = deleteNavigationItem;
exports.editNavigationItem = editNavigationItem;
exports.fetchNavigationItemsRequest = fetchNavigationItemsRequest;
exports.fetchNavigationItemsFailure = fetchNavigationItemsFailure;
exports.fetchNavigationItemsSuccess = fetchNavigationItemsSuccess;
exports.fetchNavigationItems = fetchNavigationItems;
exports.fetchPagesRequest = fetchPagesRequest;
exports.fetchPagesFailure = fetchPagesFailure;
exports.fetchPagesSuccess = fetchPagesSuccess;
exports.fetchPages = fetchPages;
exports.sortNavigationItemsRequest = sortNavigationItemsRequest;
exports.sortNavigationItemsFailure = sortNavigationItemsFailure;
exports.sortNavigationItemsSuccess = sortNavigationItemsSuccess;
exports.sortNavigationItems = sortNavigationItems;
exports.toggleSectionExpanded = toggleSectionExpanded;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _jsonFetch = require('json-fetch');

var _jsonFetch2 = _interopRequireDefault(_jsonFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD_LINK = exports.ADD_LINK = 'CADMUS_NAVBAR_ADMIN_ADD_LINK';
var ADD_SECTION = exports.ADD_SECTION = 'CADMUS_NAVBAR_ADMIN_ADD_SECTION';
var CANCEL_EDITING_NAVIGATION_ITEM = exports.CANCEL_EDITING_NAVIGATION_ITEM = 'CADMUS_NAVBAR_ADMIN_CANCEL_EDITING_NAVIGATION_ITEM';
var CHANGE_EDITING_NAVIGATION_ITEM = exports.CHANGE_EDITING_NAVIGATION_ITEM = 'CADMUS_NAVBAR_ADMIN_CHANGE_EDITING_NAVIGATION_ITEM';
var COMMIT_EDITING_NAVIGATION_ITEM_REQUEST = exports.COMMIT_EDITING_NAVIGATION_ITEM_REQUEST = 'CADMUS_NAVBAR_ADMIN_COMMIT_EDITING_NAVIGATION_ITEM_REQUEST';
var COMMIT_EDITING_NAVIGATION_ITEM_FAILURE = exports.COMMIT_EDITING_NAVIGATION_ITEM_FAILURE = 'CADMUS_NAVBAR_ADMIN_COMMIT_EDITING_NAVIGATION_ITEM_FAILURE';
var COMMIT_EDITING_NAVIGATION_ITEM_SUCCESS = exports.COMMIT_EDITING_NAVIGATION_ITEM_SUCCESS = 'CADMUS_NAVBAR_ADMIN_COMMIT_EDITING_NAVIGATION_ITEM_SUCCESS';
var DELETE_NAVIGATION_ITEM_REQUEST = exports.DELETE_NAVIGATION_ITEM_REQUEST = 'CADMUS_NAVBAR_ADMIN_DELETE_NAVIGATION_ITEM_REQUEST';
var DELETE_NAVIGATION_ITEM_FAILURE = exports.DELETE_NAVIGATION_ITEM_FAILURE = 'CADMUS_NAVBAR_ADMIN_DELETE_NAVIGATION_ITEM_FAILURE';
var DELETE_NAVIGATION_ITEM_SUCCESS = exports.DELETE_NAVIGATION_ITEM_SUCCESS = 'CADMUS_NAVBAR_ADMIN_DELETE_NAVIGATION_ITEM_SUCCESS';
var EDIT_NAVIGATION_ITEM = exports.EDIT_NAVIGATION_ITEM = 'CADMUS_NAVBAR_ADMIN_EDIT_NAVIGATION_ITEM';
var FETCH_NAVIGATION_ITEMS_REQUEST = exports.FETCH_NAVIGATION_ITEMS_REQUEST = 'CADMUS_NAVBAR_ADMIN_FETCH_NAVIGATION_ITEMS_REQUEST';
var FETCH_NAVIGATION_ITEMS_FAILURE = exports.FETCH_NAVIGATION_ITEMS_FAILURE = 'CADMUS_NAVBAR_ADMIN_FETCH_NAVIGATION_ITEMS_FAILURE';
var FETCH_NAVIGATION_ITEMS_SUCCESS = exports.FETCH_NAVIGATION_ITEMS_SUCCESS = 'CADMUS_NAVBAR_ADMIN_FETCH_NAVIGATION_ITEMS_SUCCESS';
var FETCH_PAGES_REQUEST = exports.FETCH_PAGES_REQUEST = 'CADMUS_NAVBAR_ADMIN_FETCH_PAGES_REQUEST';
var FETCH_PAGES_FAILURE = exports.FETCH_PAGES_FAILURE = 'CADMUS_NAVBAR_ADMIN_FETCH_PAGES_FAILURE';
var FETCH_PAGES_SUCCESS = exports.FETCH_PAGES_SUCCESS = 'CADMUS_NAVBAR_ADMIN_FETCH_PAGES_SUCCESS';
var SORT_NAVIGATION_ITEMS_REQUEST = exports.SORT_NAVIGATION_ITEMS_REQUEST = 'CADMUS_NAVBAR_ADMIN_SORT_NAVIGATION_ITEMS_REQUEST';
var SORT_NAVIGATION_ITEMS_FAILURE = exports.SORT_NAVIGATION_ITEMS_FAILURE = 'CADMUS_NAVBAR_ADMIN_SORT_NAVIGATION_ITEMS_FAILURE';
var SORT_NAVIGATION_ITEMS_SUCCESS = exports.SORT_NAVIGATION_ITEMS_SUCCESS = 'CADMUS_NAVBAR_ADMIN_SORT_NAVIGATION_ITEMS_SUCCESS';
var TOGGLE_SECTION_EXPANDED = exports.TOGGLE_SECTION_EXPANDED = 'CADMUS_NAVBAR_ADMIN_TOGGLE_SECTION_EXPANDED';

function saveUrlForNavigationItem(navigationItem, baseUrl) {
  var url = baseUrl;
  if (navigationItem.id) {
    url += '/' + navigationItem.id;
  }

  return url;
}

function saveNavigationItem(navigationItem, url, csrfToken) {
  var method = 'POST';
  if (navigationItem.id) {
    method = 'PATCH';
  }

  return (0, _jsonFetch2.default)(url, {
    method: method,
    headers: {
      'X-CSRF-Token': csrfToken
    },
    body: navigationItem,
    expectedStatuses: [201, 202]
  });
}

function expectResponseStatuses(statuses) {
  return function (response) {
    if (!statuses.includes(response.status)) {
      return response.json().then(function (json) {
        return new Error(json.error);
      }).catch(function () {
        return response.text().then(function (text) {
          return new Error(text);
        });
      }).then(function (error) {
        throw error;
      });
    }

    return response;
  };
}

function addLink(navigationSectionId) {
  return {
    type: ADD_LINK,
    navigationSectionId: navigationSectionId
  };
}

function addSection() {
  return {
    type: ADD_SECTION
  };
}

function cancelEditingNavigationItem() {
  return {
    type: CANCEL_EDITING_NAVIGATION_ITEM
  };
}

function changeEditingNavigationItem(newProps) {
  return {
    type: CHANGE_EDITING_NAVIGATION_ITEM,
    newProps: newProps
  };
}

function commitEditingNavigationItemRequest(url) {
  return {
    type: COMMIT_EDITING_NAVIGATION_ITEM_REQUEST,
    url: url
  };
}

function commitEditingNavigationItemFailure(error) {
  return {
    type: COMMIT_EDITING_NAVIGATION_ITEM_FAILURE,
    error: error
  };
}

function commitEditingNavigationItemSuccess(json) {
  return {
    type: COMMIT_EDITING_NAVIGATION_ITEM_SUCCESS,
    json: json
  };
}

function commitEditingNavigationItem(baseUrl) {
  return function (dispatch, getState) {
    var _getState = getState(),
        editingNavigationItem = _getState.editingNavigationItem,
        csrfToken = _getState.csrfToken;

    var url = saveUrlForNavigationItem(editingNavigationItem, baseUrl);

    dispatch(commitEditingNavigationItemRequest(url));
    saveNavigationItem(editingNavigationItem, url, csrfToken).then(function (response) {
      return dispatch(commitEditingNavigationItemSuccess(response.body));
    }).catch(function (error) {
      return dispatch(commitEditingNavigationItemFailure(error));
    });
  };
}

function deleteNavigationItemRequest(url, navigationItem) {
  return {
    type: DELETE_NAVIGATION_ITEM_REQUEST,
    url: url,
    navigationItem: navigationItem
  };
}

function deleteNavigationItemFailure(error, navigationItem) {
  return {
    type: DELETE_NAVIGATION_ITEM_FAILURE,
    error: error,
    navigationItem: navigationItem
  };
}

function deleteNavigationItemSuccess(json, navigationItem) {
  return {
    type: DELETE_NAVIGATION_ITEM_SUCCESS,
    json: json,
    navigationItem: navigationItem
  };
}

function deleteNavigationItem(baseUrl, navigationItem) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        csrfToken = _getState2.csrfToken;

    var url = baseUrl + '/' + navigationItem.id;

    dispatch(deleteNavigationItemRequest(url, navigationItem));
    (0, _isomorphicFetch2.default)(url, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      credentials: 'include'
    }).then(expectResponseStatuses([200])).then(function (response) {
      return dispatch(deleteNavigationItemSuccess(response.body, navigationItem));
    }).catch(function (error) {
      return dispatch(deleteNavigationItemFailure(error, navigationItem));
    });
  };
}

function editNavigationItem(navigationItem) {
  return {
    type: EDIT_NAVIGATION_ITEM,
    navigationItem: navigationItem
  };
}

function fetchNavigationItemsRequest(url) {
  return {
    type: FETCH_NAVIGATION_ITEMS_REQUEST,
    url: url
  };
}

function fetchNavigationItemsFailure(error) {
  return {
    type: FETCH_NAVIGATION_ITEMS_FAILURE,
    error: error
  };
}

function fetchNavigationItemsSuccess(json, csrfToken) {
  return {
    type: FETCH_NAVIGATION_ITEMS_SUCCESS,
    json: json,
    csrfToken: csrfToken
  };
}

function fetchNavigationItems(url) {
  return function (dispatch) {
    dispatch(fetchNavigationItemsRequest(url));
    (0, _jsonFetch2.default)(url, { method: 'GET', expectedStatuses: [200] }).then(function (response) {
      return dispatch(fetchNavigationItemsSuccess(response.body.navigation_items, response.body.csrf_token));
    }).catch(function (error) {
      return dispatch(fetchNavigationItemsFailure(error));
    });
  };
}

function fetchPagesRequest(url) {
  return {
    type: FETCH_PAGES_REQUEST,
    url: url
  };
}

function fetchPagesFailure(error) {
  return {
    type: FETCH_PAGES_FAILURE,
    error: error
  };
}

function fetchPagesSuccess(json) {
  return {
    type: FETCH_PAGES_SUCCESS,
    json: json
  };
}

function fetchPages(url) {
  return function (dispatch) {
    dispatch(fetchPagesRequest(url));
    (0, _jsonFetch2.default)(url, { method: 'GET', expectedStatuses: [200] }).then(function (response) {
      return dispatch(fetchPagesSuccess(response.body));
    }).catch(function (error) {
      return dispatch(fetchPagesFailure(error));
    });
  };
}

function sortNavigationItemsRequest(url, newNavigationItems) {
  return {
    type: SORT_NAVIGATION_ITEMS_REQUEST,
    newNavigationItems: newNavigationItems
  };
}

function sortNavigationItemsFailure(error) {
  return {
    type: SORT_NAVIGATION_ITEMS_FAILURE,
    error: error
  };
}

function sortNavigationItemsSuccess(newNavigationItems) {
  return {
    type: SORT_NAVIGATION_ITEMS_SUCCESS,
    newNavigationItems: newNavigationItems
  };
}

function sortNavigationItems(baseUrl, newNavigationItems) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        csrfToken = _getState3.csrfToken;

    var payload = {
      navigation_items: newNavigationItems.map(function (navigationItem) {
        return {
          id: navigationItem.id,
          position: navigationItem.position,
          navigation_section_id: navigationItem.navigation_section_id
        };
      })
    };

    var url = baseUrl + '/sort';

    dispatch(sortNavigationItemsRequest(url, newNavigationItems));
    (0, _isomorphicFetch2.default)(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify(payload),
      credentials: 'include'
    }).then(expectResponseStatuses([200])).then(function () {
      return dispatch(sortNavigationItemsSuccess(newNavigationItems));
    }).catch(function (error) {
      return dispatch(sortNavigationItemsFailure(error));
    });
  };
}

function toggleSectionExpanded(navigationSectionId) {
  return {
    type: TOGGLE_SECTION_EXPANDED,
    navigationSectionId: navigationSectionId
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/actions.js
// module id = 20
// module chunks = 0